<template>
<div class="CreateService page" v-if="$store.getters['auth/isAllowed']('can_view_admin_panel')">
    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <div class=" d-flex align-center pb-4 mb-4">
      <h1 class="font-lg">
        <span v-if="editPage">Изменить услугу</span>
        <span v-else>Добавить услугу</span>
      </h1>
    </div>
  <div class="nomenclatureBlock" v-if="stepCreating === 0 && !loadingService">
    <v-autocomplete
      v-model="nomenclatureId"
      :items="nomenclatureOptions"
      item-text="label"
      item-value="id"
      label="Номенклатура (тест кошелька)"
      hint="По ней определяется кошелёк при оформлении заказа. Для консультаций и обучения оставьте пустым."
      persistent-hint
      outlined
      dense
      clearable
      :loading="nomenclatureLoading"
      :error-messages="nomenclatureError"
      no-data-text="Номенклатур нет"
    />
  </div>
  <div class="fieldWrapper" v-if="stepCreating === 0 && !loadingService">
    <div
      v-for="(field,idx) of baseFieldService"
      :key="field.id"
      :style="`width: ${field.widthContainer}`"
    >
      <base-field-service
        :type="field.type"
        :placeholder="field.placeholder"
        :actions="field.actions"
        :widthContainer="field.widthContainer"
        :inputType="field.inputType || 'text'"
        :inputValue="field.inputValue"
        :inputWidth="field.inputWidth"
        :inputHeight="field.inputHeight"
        :inputAppendText="field.inputAppendText"
        :inputAppendIcon="field.inputAppendIcon"
        :btnInner="field.btnInner"
        :btnInnerTitle="field.btnInnerTitle"
        :btnSlot="field.btnSlot"
        :main-image="field.mainImage || {}"
        :mainImageBase64="field.mainImageBase64 || ''"
        :preview="field.preview"
        :previewBase64="field.previewBase64"
        :previewFile="field.previewFile"
        :previewFileBase64="field.previewFileBase64"
        :cards="field.cards"
        :error="getFieldError(idx)"
        :editPage="editPage"
        @btnInnerClick="btnInnerClick"
        @update:mainInput="(val) => updateMainInput(field.id,val)"
        @update:mainImage="(image) => updateMainImage(field.id,image)"
        @clearMainImage="()=>clearMainImage(field.id)"
        @update:cardImage="(card,image)=>updateCardImage(field.id,card,image)"
        @update:cardDescription="(val,card)=>updateDescriptionCard(field.id,val,card)"
        @deleteImageCard="(card)=>deleteImageCard(field.id,card)"
        @update:preview="(preview) => updatePreview(field.id,preview)"
        @clearPreview="()=>clearPreview(field.id)"

      >
        <template v-slot:btnDownBlock v-if="field.btnSlot">
          <div class="d-flex ">
            <v-btn
              large
              color="white"
              outlined
            >
              Добавить в корзину
            </v-btn>
          </div>
          <div>
            <v-btn
              class="background_transparent"
              large
              color="white"
              outlined
            >
              Образец отчета
            </v-btn>
          </div>
        </template>

      </base-field-service>

    </div>
    <div class="btnDownBlocks">
      <v-btn
        large
        class="background_transparent"
        color="white"
        outlined
      >
        Отменить
      </v-btn>
      <v-btn
        large
        class=""
        color="white"
        outlined
        @click="goToPreview"
      >
        Просмотреть
      </v-btn>
    </div>
  </div>
  <CreateServiceSkeleton v-else-if="loadingService"/>
  <div class="fieldWrapper__preview" v-if="stepCreating === 1">
    <div class="loadingPreview" v-if="loadingPreview">
      <CreateServiceSkeleton/>
    </div>
    <div v-else>
      <CreateServicePreview
        :data="baseFieldService"
      />
    </div>
    <div class="btnDownBlocks">
      <v-btn
        large
        class="background_transparent"
        color="white"
        outlined
        @click="goToCreate()"
      >
        Изменить
      </v-btn>
      <v-btn
        large
        class=""
        color="white"
        outlined
        @click="editPage ? updateServiceCard() : showModalCreatingSteps = true"
      >
        <span v-if="editPage">Обновить</span>
        <span v-else>Сохранить</span>

      </v-btn>
    </div>
  </div>
  <ModalSuccessDelete
    :show-dlg-delete=" editPage ? GET_SUCCESS_MODAL_UPDATE : GET_SUCCESS_MODAL_CREATE "
    :success-text="editPage ? 'Карточка услуги успешно обновлена' : 'Карточка услуги успешно создана'"
    @closeModal="closeSuccesModal"
  />
  <ModalCreatingCard
    :value="showModalCreatingSteps"
    :steps-creating="GET_STEPS_CREATING"
    :create-card-function="createServiceCard"
    @closeModal="closeModalCreatingCard"
  />
</div>
</template>

<script>
import BaseFieldService from '@/components/admin-panel/BaseFieldService.vue';
import CreateServiceSkeleton from '@/components/admin-panel/CreateServiceSkeleton.vue';
import CreateServicePreview from '@/components/admin-panel/CreateServicePreview.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import api from '@/common/api';
import {
 between, maxLength, minLength, numeric, required
} from 'vuelidate/lib/validators';
import Vue from 'vue';
import { customCardValidators, ImageValidators as imageValidators } from '@/common/validationHelpers';
import ModalSuccessDelete from '@/components/admin-panel/Modal/ModalSuccessDelete.vue';
import ModalCreatingCard from '@/components/admin-panel/Modal/ModalStepCreating.vue';

/**
 * Компонент: CreateService
 * Описание:
 */
export default {
  name: 'CreateService',
  components: {
    ModalCreatingCard,
    ModalSuccessDelete,
CreateServicePreview,
CreateServiceSkeleton,
BaseFieldService
  },

  props: {},
  validations() {
    const rules = {};
    this.baseFieldService.forEach((field) => {
      if (field.validation) {
        const fieldName = `field_${field.field}`;

        rules[fieldName] = {};

        if (field.validation.required) {
          rules[fieldName].required = required;
        }

        if (field.validation.minLength) {
          rules[fieldName].minLength = minLength(field.validation.minLength);
        }

        if (field.validation.maxLength) {
          rules[fieldName].maxLength = maxLength(field.validation.maxLength);
        }

        if (field.type === 'number') {
          rules[fieldName].numeric = numeric;
        }

        if (field.type === 'upload' || field.type === 'uploadPreview') {
          rules[fieldName].required = required;
          rules[fieldName].maxSize = imageValidators.maxSize(20);
          rules[fieldName].format = imageValidators.format(['jpg', 'png', 'jpeg', 'webp']);
        }

        if (field.type === 'uploadPreview') {
          rules[fieldName].format = imageValidators.format(['jpg', 'png', 'jpeg', 'webp', 'pdf', 'docx', 'doc']);
        }

        if (field.type === 'card') {
          rules[fieldName].required = customCardValidators.required();
          rules[fieldName].countImage = customCardValidators.countImage();
          // rules[fieldName].maxSize = customCardValidators.maxSize(5);
           rules[fieldName].format = customCardValidators.format(['jpg', 'png', 'jpeg', 'webp']);
           rules[fieldName].requiredDescription = customCardValidators.requiredDescription();
        }

        if (field.validation.between) {
          rules[fieldName].between = between(
            field.validation.between[0],
            field.validation.between[1]
          );
        }
      }
    });

    return {
      formValues: rules
    };
  },
  data() {
    return {
      serviceTitle: '',
      nomenclatureId: null,
      // false — детали карточки не вернули поле: при сохранении его не отправляем, чтобы не стереть привязку
      nomenclatureKnown: true,
      nomenclatureOptions: [],
      allNomenclatures: [],
      nomenclatureLoading: false,
      nomenclatureError: '',
      inputWidth: '100%',
      stepCreating: 0,
      loadingPreview: false,
      baseFieldServiceProxy: [],
      touchedFields: {},
      formValues: {},
      showModalCreatingSteps: false,
      creationProcess: {
        isLoading: false,
        progress: 0,
        currentStep: '',
        totalSteps: 6,
        errors: [],
        createdEntities: [],
      },
      temporaryState: {
        card: null,
        modules: {
          mainImage: null,
          features: null,
          contactButton: null,
          reportPreview: null
        }
      },
    };
  },

  computed: {
    ...mapGetters({
      serviceCreatingDetails: 'services/services/GET_SERVICE_CREATING_DETAILS',
      serviceDetails: 'services/services/GET_DETAIL_SERVICE_PREVIEW',
      baseFieldServiceStore: 'services/services/GET_BASE_FIELDS',
      loadingService: 'services/services/GET_LOADING_SERVICES',
      GET_SUCCESS_MODAL_CREATE: 'services/services/GET_SUCCESS_MODAL_CREATE',
      GET_SUCCESS_MODAL_UPDATE: 'services/services/GET_SUCCESS_MODAL_UPDATE',
      GET_CURRENT_STEP_CREATING: 'services/services/GET_CURRENT_STEP_CREATING',
      GET_STEPS_CREATING: 'services/services/GET_STEPS_CREATING',
    }),
    breadcrumbs() {
      return [
        { title: 'Админка', url: '/admin-panel' },
        { title: 'Управление услугами', url: '/admin-panel/services' },
        { title: `${this.editPage ? 'Изменить услугу' : 'Добавить услугу'}`, url: '' },
      ];
    },
    baseFieldServiceItems: {
      get() {
        return JSON.parse(JSON.stringify(this.baseFieldService));
      },
      set(val) {
        this.baseFieldService = val;
      }
    },
    hasValidationErrors() {
      return this.$v.$invalid;
    },
    editPage() {
      return this.$route.name === 'update-service';
    },
    editPageId() {
      return (this.$route.name === 'update-service' && this.$route.params.id) ? this.$route.params.id : '';
    },
    baseFieldService: {
      get() {
        return this.baseFieldServiceStore;
      },
      set(value) {
        this.SET_BASE_FIELDS(value);
      }
    },
    stepStatus() {
      return {
        cardCreated: !!this.temporaryState.card,
        mainImageCreated: !!this.temporaryState.modules.mainImage,
        featuresCreated: !!this.temporaryState.modules.features,
        contactButtonCreated: !!this.temporaryState.modules.contactButton,
        reportPreviewCreated: !!this.temporaryState.modules.reportPreview
      };
    },
    serviceModules() {
      const modules = {
        main_image: null,
        features: {
          title: '',
          images: []
        },
        contact_button: '',
        report_preview: null,
      };

      this.baseFieldService.forEach((field) => {
        switch (field.field) {
          case 'mainImage':
            modules.main_image = field.mainImage;
            break;

          case 'cardTitle':
            modules.features.title = field.inputValue || '';
            break;

          case 'card':
            if (Array.isArray(field.cards)) {
              modules.features.images = field.cards.map(card => ({
                image: card.image,
                description: card.description || '',
                title: card.title || ''
              }));
            }
            break;

          case 'callBack':
            modules.contact_button = field.inputValue || '';
            break;

          case 'report_preview': {
            const hasValidPreviewFile = field?.previewFile && (
              field.previewFile instanceof File
              || field.previewFile instanceof Blob
              || (typeof field.previewFile === 'object' && Object.keys(field.previewFile).length > 0)
            );

            const hasValidPreview = field?.preview && (
              field.preview instanceof File
              || field.preview instanceof Blob
              || (typeof field.preview === 'object' && Object.keys(field.preview).length > 0)
            );

            let result = {};
            if (hasValidPreviewFile) {
              result = field.previewFile;
            } else if (hasValidPreview) {
              result = field.preview;
            }

            modules.report_preview = result;
            break;
          }
          default:
            break;
        }
      });

      return modules;
    }
  },

  watch: {
    baseFieldServiceProxy: {
      handler(newVal) {
        this.baseFieldServiceItems = [...newVal];
      },
      deep: true,
    }
  },

  created() {
    this.initializeFormValues();
  },
  async mounted() {
    this.loadNomenclatures();
    if (this.editPageId) {
     await this.GET_DETAIL_SERVICE_CARD(this.editPageId);
     await this.fillRequiredFields();
    }
    this.baseFieldServiceProxy = [...this.baseFieldService];
  },

  beforeDestroy() {
    this.CLEAR_BASE_FIELDS();
  },

  methods: {
    // Список номенклатур для связи карточки с кошельком (GET /stock/nomenclatures/).
    async loadNomenclatures() {
      this.nomenclatureLoading = true;
      this.nomenclatureError = '';
      try {
        const list = await api.get('/stock/nomenclatures/');
        this.allNomenclatures = Array.isArray(list) ? list : (list.results || []);
        this.nomenclatureOptions = this.allNomenclatures
          .filter((n) => n.is_active !== false && n.is_licensed !== false)
          .map((n) => ({ id: n.id, label: n.name ? `${n.name} (${n.code})` : n.code }));
        this.keepSelectedNomenclature();
      } catch (e) {
        this.nomenclatureError = 'Не удалось загрузить список номенклатур';
      } finally {
        this.nomenclatureLoading = false;
      }
    },
    // Уже выбранная номенклатура остаётся в списке, даже если стала неактивной или без лицензии
    keepSelectedNomenclature() {
      const id = this.nomenclatureId;
      if (id == null || this.nomenclatureOptions.some((o) => String(o.id) === String(id))) return;
      const n = (this.allNomenclatures || []).find((x) => String(x.id) === String(id));
      if (!n) return;
      const label = n.name ? `${n.name} (${n.code})` : n.code;
      this.nomenclatureOptions = [...this.nomenclatureOptions, { id: n.id, label: `${label} — неактивна` }];
    },
    // Поле номенклатуры в теле запроса; если форма его не знает, не отправляем
    nomenclaturePayload() {
      return this.nomenclatureKnown ? { nomenclature: this.nomenclatureId || null } : {};
    },
    // Ответ сервера: id или объект с id
    nomenclatureIdOf(value) {
      return value && typeof value === 'object' ? value.id : value;
    },
    // Бэк может не принять поле: тогда после сохранения номенклатура останется прежней, предупреждаем админа.
    warnIfNomenclatureNotSaved(card) {
      if (!card || this.nomenclatureId == null) return;
      if (String(this.nomenclatureIdOf(card.nomenclature) || '') === String(this.nomenclatureId)) return;
      this.$toast.warning('Карточка сохранена, но номенклатура не записалась — поле пока недоступно на сервере', '', { position: 'topRight' });
    },
    ...mapActions({
      // CREATE CARD
      CREATE_SERVICE_CARD: 'services/services/CREATE_SERVICE_CARD',
      CREATE_MODULES: 'services/services/CREATE_MODULES',
      CREATE_IMAGES_BLOCK_FOR_MODULE: 'services/services/CREATE_IMAGES_BLOCK_FOR_MODULE',
      CREATE_FILES_BLOCK_FOR_MODULE: 'services/services/CREATE_FILES_BLOCK_FOR_MODULE',
      UPLOAD_IMAGES_IN_MODULE: 'services/services/UPLOAD_IMAGES_IN_MODULE',
      UPLOAD_FILES_IN_MODULE: 'services/services/UPLOAD_FILES_IN_MODULE',

      // UPDATE CARD
      UPDATE_SERVICE_CARD: 'services/services/UPDATE_SERVICE_CARD',
      UPDATE_MODULE: 'services/services/UPDATE_MODULE',
      UPDATE_IMAGES_BLOCK_FOR_MODULE: 'services/services/UPDATE_IMAGES_BLOCK_FOR_MODULE',
      GET_DETAIL_SERVICE_CARD: 'services/services/GET_DETAIL_SERVICE',

      // DELETE
      DELETE_MODULE_IMAGES: 'services/services/DELETE_MODULE_IMAGES',
      DELETE_MODULE_FILES: 'services/services/DELETE_MODULE_FILES',
    }),
    ...mapMutations({
      SET_CREATE_SERVICE_DETAIL: 'services/services/SET_CREATE_SERVICE_DETAIL',
      SET_BASE_FIELDS: 'services/services/SET_BASE_FIELDS',
      CLEAR_BASE_FIELDS: 'services/services/CLEAR_BASE_FIELDS',
      SET_SUCCESS_MODAL_CREATE: 'services/services/SET_SUCCESS_MODAL_CREATE',
      SET_SUCCESS_MODAL_UPDATE: 'services/services/SET_SUCCESS_MODAL_UPDATE',
      SET_CURRENT_STEP_CREATING: 'services/services/SET_CURRENT_STEP_CREATING',
      CHANGE_STATUS_STEP_CREATING: 'services/services/CHANGE_STATUS_STEP_CREATING',
      CHANGE_STATUS_STEP_CREATING_MODULE: 'services/services/CHANGE_STATUS_STEP_CREATING_MODULE',
      CLEAR_STEP_CREATING: 'services/services/CLEAR_STEP_CREATING',
    }),
    // renderImage
    async renderImageBase64(image) {
      if (!image || !image.type.match('image.*')) {
        return null;
      }
      const maxSize = 5 * 1024 * 1024;
      if (image.size > maxSize) {
        return null;
      }
      try {
        return await this.readFileAsDataURL(image);
      } catch (error) {
        this.showError('Ошибка чтения файла');
        return null;
      }
    },

    // renderDocx
    async renderDocsBase64(file) {
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        return null;
      }
      try {
        return await this.readFileAsDataURL(file);
      } catch (error) {
        this.showError('Ошибка чтения файла');
        return null;
      }
    },
    readFileAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);

        reader.readAsDataURL(file);
      });
    },
    findIdxField(fieldId) {
     return this.baseFieldServiceProxy.findIndex((field) => field.id === fieldId);
    },
    updateMainInput(fieldId, inputValue) {
      const index = this.findIdxField(fieldId);
      this.baseFieldServiceProxy[index].inputValue = inputValue;
      this.updateField(index, inputValue);
    },
    async updateCardImage(fieldId, card, image) {
      const index = this.findIdxField(fieldId);
      if (index !== -1 && card.id) {
        const idxCard = this.baseFieldServiceProxy[index].cards.findIndex((item) => item.id === card.id);
        if (idxCard !== -1) {
          const renderImageToBase64 = await this.renderImageBase64(image);
          if (renderImageToBase64) {
            this.baseFieldServiceProxy[index].cards[idxCard].imageBase64 = renderImageToBase64;
            this.updateField(index, this.baseFieldServiceProxy[index].cards, 'card');
          }
          this.baseFieldServiceProxy[index].cards[idxCard].image = image;
        }
      }
    },
    updateDescriptionCard(fieldId, value, card) {
      const index = this.findIdxField(fieldId);
      if (index !== -1 && card.id) {
        const idxCard = this.baseFieldServiceProxy[index].cards.findIndex((item) => item.id === card.id);
        if (idxCard !== -1) {
          this.baseFieldServiceProxy[index].cards[idxCard].description = value;
          this.updateField(index, this.baseFieldServiceProxy[index].cards, 'card');
        }
      }
    },
    deleteImageCard(fieldId, card) {
      const index = this.findIdxField(fieldId);
      if (index !== -1 && card.id) {
        const idxCard = this.baseFieldServiceProxy[index].cards.findIndex((item) => item.id === card.id);
        if (idxCard !== -1) {
          this.baseFieldServiceProxy[index].cards[idxCard].image = null;
          this.baseFieldServiceProxy[index].cards[idxCard].imageBase64 = null;
          this.updateField(index, this.baseFieldServiceProxy[index].cards[idxCard].image, 'card');
        }
      }
    },
    async updateMainImage(fieldId, image) {
      const index = this.findIdxField(fieldId);
      const rendeImageToBase64 = await this.renderImageBase64(image);
      if (rendeImageToBase64) {
        this.baseFieldServiceProxy[index].mainImageBase64 = rendeImageToBase64;
        this.updateField(index, image, 'file');
      }
      this.baseFieldServiceProxy[index].mainImage = image;
    },
    btnInnerClick() {},
    clearMainImage(fieldId) {
      const index = this.findIdxField(fieldId);
      this.baseFieldServiceProxy[index].mainImage = '';
      this.baseFieldServiceProxy[index].mainImageBase64 = '';
      this.updateField(index, '', 'file');
    },
    async updatePreview(fieldId, preview) {
      const documentExtensions = ['pdf', 'docx', 'doc'];
      const index = this.findIdxField(fieldId);
      const fileExtension = preview.name.split('.').pop();
      const docFile = documentExtensions.includes(fileExtension.toLowerCase());
      if (docFile) {
        const renderDocToBase64 = await this.renderDocsBase64(preview);
        this.baseFieldServiceProxy[index].previewFileBase64 = renderDocToBase64;
        this.updateField(index, preview, 'file');
        this.baseFieldServiceProxy[index].previewFile = preview;
      } else {
        const rendeImageToBase64 = await this.renderImageBase64(preview);
        if (rendeImageToBase64) {
          this.baseFieldServiceProxy[index].previewBase64 = rendeImageToBase64;
          this.updateField(index, preview, 'file');
          this.baseFieldServiceProxy[index].preview = preview;
        }
      }
    },
    clearPreview(fieldId) {
      const index = this.findIdxField(fieldId);
      this.baseFieldServiceProxy[index].preview = {};
      this.baseFieldServiceProxy[index].previewBase64 = '';
      this.baseFieldServiceProxy[index].previewFile = {};
      this.baseFieldServiceProxy[index].previewFileBase64 = '';
      this.updateField(index, {}, 'file');
    },
    goToPreview() {
      this.onProgress('InitializationCreating');
      this.onStepDetail({ name: 'InitializationCreating', status: 'started' });
      this.baseFieldService.forEach((field, index) => {
        this.touchField(index);
      });
      if (this.$v.$invalid) {
        Vue.prototype.$toast.error('Форма заполнена некорректно', '', { position: 'bottomCenter' });
        return;
      }

      this.loadingPreview = true;
      this.stepCreating = 1;

      setTimeout(() => {
        this.loadingPreview = false;
        this.onStepDetail({ name: 'InitializationCreating', status: 'finished' });
      }, 1000);
    },
    goToCreate() {
      this.stepCreating = 0;
    },
    closeModalCreatingCard() {
      this.showModalCreatingSteps = false;
      this.CLEAR_STEP_CREATING();
      if (this.GET_CURRENT_STEP_CREATING === 'finished') {
        this.SET_SUCCESS_MODAL_CREATE(true);
      }
    },

    // FIX
    onProgress(step) {
      this.SET_CURRENT_STEP_CREATING(step);
    },
    onStepDetail(data) {
      this.CHANGE_STATUS_STEP_CREATING(data);
    },
    onStepDetailModule(data) {
      this.CHANGE_STATUS_STEP_CREATING_MODULE(data);
    },
    prepareRequiredField() {
      const mainFieldCard = {
        name: this.getFieldValue('mainTitle'),
        short_description: this.getFieldValue('shortDescription'),
        full_description: this.getFieldValue('fullDescription'),
        price: this.getFieldValue('price', 'number'),
        discount_price: this.getFieldValue('sale', 'number'),
        ...this.nomenclaturePayload(),
        order: 0,
        is_promo: true,
        is_active: true
      };
      return mainFieldCard;
    },
    getFieldValue(searchField, type = null) {
      const field = this.baseFieldService.find(field => field.field === searchField);
      if (field) {
        if (type === 'number') {
          return Number(field.inputValue);
        } if (type === 'mainImage') {
          return field.mainImage;
        } if (type === 'reportPreview') {
          if (field.preview instanceof File) {
            return { type: 'image', preview: field.preview };
          }
          if (field.previewFile instanceof File) {
            return { type: 'file', preview: field.previewFile };
          }
        }
        if (type === 'card_block') {
          return field.cards;
        }
          return field.inputValue;
      }

        return false;
    },
    // UTILS
    async createModule(type, text = null) {
      try {
        const data = {
          card: this.temporaryState.card,
          module: {
            module_type: type,
            text: text || ''
          }
        };
        return await this.CREATE_MODULES(data);
      } catch (error) {
        throw new Error(error);
      }
    },

    async createImageModule(module) {
      try {
          const data = {
            id: module.moduleId,
            caption: module.caption || '',
          };
          return await this.CREATE_IMAGES_BLOCK_FOR_MODULE(data);
      } catch (error) {
        throw new Error(error);
      }
    },
    async createFilesModule(module) {
      try {
        const data = {
          id: module.moduleId,
          caption: module.caption || '',
        };
        return await this.CREATE_FILES_BLOCK_FOR_MODULE(data);
      } catch (error) {
        throw new Error(error);
      }
    },
    async uploadImageModule(imageId, file) {
      try {
          const formData = new FormData();
          formData.set('file', file);
          const data = {
            formData,
            id: imageId
          };
          return await this.UPLOAD_IMAGES_IN_MODULE(data);
      } catch (error) {
        throw new Error(error);
      }
    },
    async uploadFilesModule(imageId, file) {
      try {
        const formData = new FormData();
        formData.set('file', file);
        const data = {
          formData,
          id: imageId
        };
        return await this.UPLOAD_FILES_IN_MODULE(data);
      } catch (error) {
        throw new Error(error);
      }
    },
    async deleteModuleImage(type, moduleId) {
      if (type === 'image') {
          await this.DELETE_MODULE_IMAGES({ id: moduleId });
      }
      if (type === 'file') {
        await this.DELETE_MODULE_FILES({ id: moduleId });
      }
    },

    async createMainImageModuleStep() {
      try {
        const image = this.getFieldValue('mainImage', 'mainImage');
        this.temporaryState.modules.mainImage = await this.createModule('main_image');
        this.temporaryState.modules.mainImage.images = await this.createImageModule({ moduleId: this.temporaryState.modules.mainImage.id });
        const res = await this.uploadImageModule(this.temporaryState.modules.mainImage.images.id, image);
        if (res) {
          return { success: true };
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    async createReportModuleStep(update = false) {
      try {
        const preview = this.getFieldValue('report_preview', 'reportPreview');
        if (!update) {
          this.temporaryState.modules.reportPreview = await this.createModule('report_preview');
        }
        if (update) {
          const idxReportModule = this.serviceDetails.modules.findIndex(item => item.module_type === 'report_preview');
          if (idxReportModule !== -1) {
            this.temporaryState.modules.reportPreview = this.serviceDetails.modules[idxReportModule];
          }
        }
        if (preview.type === 'image') {
          this.temporaryState.modules.reportPreview.images = await this.createImageModule({ moduleId: this.temporaryState.modules.reportPreview.id });
          const res = await this.uploadImageModule(this.temporaryState.modules.reportPreview.images.id, preview.preview);
          if (res.id) {
            this.onStepDetail({ name: 'report_preview', status: 'finished' });
            return {
              success: true,
            };
          }
          let errorMessage = 'Не удалось создать модуль превью';
          if (res.data && typeof res.data === 'object') {
            const errors = [];
            Object.entries(res.data).forEach(([field, fieldErrors]) => {
              if (Array.isArray(fieldErrors) && fieldErrors[0]) {
                errors.push(`${field}: ${fieldErrors[0]}`);
              } else {
                errors.push(`${field}: ${fieldErrors}`);
              }
            });
            if (errors.length > 0) {
              errorMessage = errors.join('; ');
            }
          }
          throw new Error(errorMessage);
        }
        if (preview.type === 'file') {
          this.temporaryState.modules.reportPreview.files = await this.createFilesModule({ moduleId: this.temporaryState.modules.reportPreview.id });
          const res = await this.uploadFilesModule(this.temporaryState.modules.reportPreview.files.id, preview.preview);
          if (res.id) {
            this.onStepDetail({ name: 'report_preview', status: 'finished' });
            return {
              success: true,
            };
          }
          let errorMessage = 'Не удалось создать модуль превью';
          if (res.data && typeof res.data === 'object') {
            const errors = [];
            Object.entries(res.data).forEach(([field, fieldErrors]) => {
              if (Array.isArray(fieldErrors) && fieldErrors[0]) {
                errors.push(`${field}: ${fieldErrors[0]}`);
              } else {
                errors.push(`${field}: ${fieldErrors}`);
              }
            });
            if (errors.length > 0) {
              errorMessage = errors.join('; ');
            }
          }
          throw new Error(errorMessage);
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    async createContactButtonStep() {
      try {
        const contactButton = this.getFieldValue('callBack');
        if (!contactButton) {
          throw new Error('Ошибка при создании контактной кнопки');
        }
        this.temporaryState.modules.contactButton = await this.createModule('contact_button', contactButton);
        if (this.temporaryState.modules.contactButton.id) {
          return { success: true };
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    async createFeaturesModuleStep() {
      try {
        const cardTitle = this.getFieldValue('cardTitle');
        const cardBlock = this.getFieldValue('card', 'card_block');

        if (!cardBlock || !Array.isArray(cardBlock)) {
          throw new Error('Блок особенностей не был найден');
        }

        this.temporaryState.modules.features = await this.createModule('features', cardTitle);
        this.temporaryState.modules.features.images = [];

        const results = {
          created: 0,
          failed: 0,
          details: []
        };

        const cardPromises = cardBlock.map(async (card, index) => {
          const cardResult = {
            index,
            description: card.description || `Карточка ${index + 1}`,
            status: 'pending',
            cardId: null,
            uploadSuccess: false
          };

          try {
            if (!card.description?.trim()) {
              cardResult.status = 'skipped';
              cardResult.reason = 'Нет описания';
              return cardResult;
            }

            const imageBlock = await this.createImageModule({
              moduleId: this.temporaryState.modules.features.id,
              caption: card.description,
            });
             if (!imageBlock.id) {
              let errorMessage = 'Не удалось создать модуль особенностей';
              if (imageBlock.data && typeof imageBlock.data === 'object') {
                const errors = [];
                Object.entries(imageBlock.data).forEach(([field, fieldErrors]) => {
                  if (Array.isArray(fieldErrors) && fieldErrors[0]) {
                    errors.push(`${field}: ${fieldErrors[0]}`);
                  }
                });
                if (errors.length > 0) {
                  errorMessage = errors.join('; ');
                }
              }
              throw new Error(errorMessage);
            }
            cardResult.cardId = imageBlock.id;
            cardResult.status = 'card_created';
            results.created += 1;

            if (card.image) {
              try {
                await this.uploadImageModule(imageBlock.id, card.image);
                cardResult.uploadSuccess = true;
                cardResult.status = 'complete';
              } catch (uploadError) {
                cardResult.status = 'card_only';
                cardResult.uploadError = uploadError.message;
              }
            } else {
              cardResult.status = 'card_only';
            }

            this.temporaryState.modules.features.images.push(imageBlock);
          } catch (cardError) {
            cardResult.status = 'failed';
            cardResult.error = cardError.message;
            results.failed += 1;
            throw cardError;
          }

          results.details.push(cardResult);
          return cardResult;
        });
        await Promise.all(cardPromises);
        if (results.created === 0) {
          throw new Error('Не удалось создать ни одну карточку');
        }

        const hasMinCards = this.temporaryState.modules.features.images.length >= 3;

        if (this.temporaryState.modules.features.id && hasMinCards) {
          return {
            success: true,
            moduleId: this.temporaryState.modules.features.id,
            stats: results
          };
        }

        return {
          success: false,
          reason: `Создано только ${results.created} карточек (нужно минимум 3)`,
          partial: true,
          stats: results
        };
      } catch (error) {
        if (this.temporaryState.modules.features) {
          delete this.temporaryState.modules.features;
        }
        throw error;
      }
    },

    async createServiceCard() {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return undefined;
      try {
        const steps = [
          () => this.createBaseCardStep(),
          () => this.createAllModules(),
        ];
        let previousResult = null;
        for (const step of steps) {
          // eslint-disable-next-line no-await-in-loop
          const result = await step(previousResult);

          if (step === steps[0] && (!result || !result.success)) {
            return {
              success: false,
              reason: 'Основная карточка не создана',
              stoppedAt: 'createBaseCardStep'
            };
          } if (step === steps[1] && result.success) {
            this.onProgress('finished');
            this.onStepDetail({ name: 'finished', status: 'finished' });
          }
          previousResult = result;
        }
      } catch (error) {
        throw new Error(error);
      }
    },

    // step: 1
    async createBaseCardStep() {
      try {
        this.onProgress('createBaseCard');
        this.onStepDetail({ name: 'createBaseCard', status: 'started' });

        const prepareData = this.prepareRequiredField();
        const card = await this.CREATE_SERVICE_CARD(prepareData);
        if (card.id) {
          this.warnIfNomenclatureNotSaved(card);
          this.onStepDetail({ name: 'createBaseCard', status: 'finished' });
          this.temporaryState.card = card;
          return {
            success: true,
          };
        }
          let errorMessage = 'Не удалось создать карточку';
          if (card.data && typeof card.data === 'object') {
            const errors = [];
            Object.entries(card.data).forEach(([field, fieldErrors]) => {
              if (Array.isArray(fieldErrors) && fieldErrors[0]) {
                errors.push(`${field}: ${fieldErrors[0]}`);
              }
            });
            if (errors.length > 0) {
              errorMessage = errors.join('; ');
            }
          }
          throw new Error(errorMessage);
      } catch (error) {
        this.onStepDetail({ name: 'createBaseCard', status: 'error', error });
        throw error;
      }
    },
    async createMainImageModule() {
      // mainImage
      this.onProgress('createModules');
      this.onStepDetail({ name: 'createModules', status: 'started' });
      if (this.serviceModules.main_image) {
        try {
          this.onStepDetailModule({ name: 'main_image', status: 'started' });
          const res = await this.createMainImageModuleStep();
          if (res.success) {
            this.onStepDetailModule({ name: 'main_image', status: 'finished' });
          }
        } catch (error) {
          this.onStepDetailModule({ name: 'main_image', status: 'error', error });
          return error;
        }
      }
    },
    async createFeaturesModule() {
      // features
      if (this.serviceModules.features) {
        try {
          this.onStepDetailModule({ name: 'features', status: 'started' });
          const res = await this.createFeaturesModuleStep();
          if (res.success) {
            this.onStepDetailModule({ name: 'features', status: 'finished' });
          }
        } catch (error) {
          this.onStepDetailModule({ name: 'features', status: 'error', error });
          return error;
        }
      }
    },
    async createContactButtonModule() {
      // contact_button
      if (this.serviceModules.contact_button) {
        try {
          this.onStepDetailModule({ name: 'contact_button', status: 'started' });
          const res = await this.createContactButtonStep();
          if (res.success) {
            this.onStepDetailModule({ name: 'contact_button', status: 'finished' });
          }
        } catch (error) {
          this.onStepDetailModule({ name: 'contact_button', status: 'error', error });
          return error;
        }
      }
    },
    async createReportPreviewModule(update = false) {
      // report_preview
      if (this.serviceModules.report_preview) {
        try {
          this.onStepDetailModule({ name: 'report_preview', status: 'started' });
          const res = await this.createReportModuleStep(update);
          if (res.success) {
            this.onStepDetailModule({ name: 'report_preview', status: 'finished' });
          }
        } catch (error) {
          this.onStepDetailModule({ name: 'report_preview', status: 'error', error });
          return error;
        }
      }
    },
    // step: 2
    async createAllModules() {
      try {
        await this.createMainImageModule();
        await this.createFeaturesModule();
        await this.createContactButtonModule();
        await this.createReportPreviewModule();
        this.onStepDetail({ name: 'createModules', status: 'finished' });
        return {
          success: true,
        };
      } catch (error) {
        this.onStepDetail({ name: 'createModules', status: 'error', error });
        throw new Error(error);
      }
    },

    async updateServiceCard() {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      try {
        // Modules Required
        const mainImageModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'main_image');
        const cardModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'features');
        const callBackModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'contact_button');
        const previewModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'report_preview');

        /* -------------------BASE CARD-------------------------- */
        // Обновляем карточку
        // eslint-disable-next-line no-unused-vars
        const initialState = {
          createCard: null,
          mainImageModule: null,
          featuresModule: null,
          contactButtonsModule: null,
          reportPreviewModule: null,
        };
        const mainFieldCard = {
          name: this.baseFieldService.find(field => field.field === 'mainTitle').inputValue,
          short_description: this.baseFieldService.find(field => field.field === 'shortDescription').inputValue,
          full_description: this.baseFieldService.find(field => field.field === 'fullDescription').inputValue,
          price: Number(this.baseFieldService.find(field => field.field === 'price').inputValue),
          discount_price: Number(this.baseFieldService.find(field => field.field === 'sale').inputValue),
          ...this.nomenclaturePayload(),
          order: 0,
          is_promo: true,
          is_active: true
        };
        const data = {
          id: this.serviceDetails.id,
          mainFieldCard,
        };
        try {
          const card = await this.UPDATE_SERVICE_CARD(data);
          if (card) {
            initialState.createCard = card;
            this.warnIfNomenclatureNotSaved(card);
          }
        } catch (error) {
          return error;
        }
        /* -------------------END BASE CARD-------------------------- */

        /* -------------------START MAIN IMAGE-------------------------- */
        try {
          const mainImage = this.baseFieldService.find(field => field.field === 'mainImage');
          if (mainImage) {
            const formDataMainImage = new FormData();
            formDataMainImage.set('file', mainImage.mainImage);
            const data = {
              formData: formDataMainImage,
              id: this.serviceDetails.modules[mainImageModule].images[0].id,
            };
            await this.UPLOAD_IMAGES_IN_MODULE(data);
          }
        } catch (error) {
          console.log('Ошибка загрузки изображения', error);
          return error;
        }
        /* -------------------END MAIN IMAGE-------------------------- */

        /* -------------------START FEATURES-------------------------- */
        // Обновление Заголовка карточек услуг
        try {
          const cardTitleBlock = this.baseFieldService.find(field => field.field === 'cardTitle');
          const data = {
            card: {
              id: this.serviceDetails.id,
            },
            module: {
              id: this.serviceDetails.modules[cardModule].id,
              module_type: 'features',
              text: cardTitleBlock.inputValue,
            }
          };
          await this.UPDATE_MODULE(data);
        } catch (error) {
          console.error('Ошибка создания модуля (features)', error);
          return error;
        }
        // Обновление описание карточек услуг
        if (this.serviceDetails.modules[cardModule].images.length) {
          try {
            const cardBlock = this.baseFieldService.find(field => field.field === 'card');
            const uploadPromises = cardBlock.cards.map(async (card, idx) => {
              const data = {
                id: this.serviceDetails.modules[cardModule].images[idx].id,
                cardId: this.serviceDetails.modules[cardModule].id,
                caption: card.description,
              };
              try {
                const updateImagesBlockInModule = await this.UPDATE_IMAGES_BLOCK_FOR_MODULE(data);
                return { success: true, data: updateImagesBlockInModule, card };
              } catch (error) {
                return { success: false, error, card };
              }
            });
            const results = await Promise.all(uploadPromises);
            results.forEach(result => {
              if (result.success) {
                console.log('Успешно загружено:', result.data);
              } else {
                console.error('Ошибка загрузки:', result.error);
              }
            });
          } catch (error) {
            console.error('Ошибка обновления модуля изображения(features)', error);
            return error;
          }
        } else {
          // Случай, если модуль особенностей не создался!
          // Создаем изображения модуля
          try {
            initialState.featuresModule = this.serviceDetails.modules[cardModule];
            if (initialState.featuresModule) {
              const cardBlock = this.baseFieldService.find(field => field.field === 'card');
              initialState.featuresModule.images = [];
              const uploadPromises = cardBlock.cards.map(async (card) => {
                const data = {
                  id: initialState.featuresModule.id,
                  caption: card.description,
                };
                try {
                  const createImagesBlockInModule = await this.CREATE_IMAGES_BLOCK_FOR_MODULE(data);
                  initialState.featuresModule.images.push(createImagesBlockInModule);
                  return { success: true, data: createImagesBlockInModule, card };
                } catch (error) {
                  return { success: false, error, card };
                }
              });
              const results = await Promise.all(uploadPromises);
              results.forEach(result => {
                if (result.success) {
                  console.log('Успешно загружено:', result.data);
                } else {
                  console.error('Ошибка загрузки:', result.error);
                }
              });
            } else {
              console.log('Cоздание модуля невозможно, прошлый шаг не выполнен', initialState);
            }
          } catch (error) {
            console.error('Ошибка создания модуля изображения(features)', error);
            return error;
          }
          // Загружаем в модуль изображение
          try {
            if (initialState.featuresModule.images && initialState.featuresModule.images.length) {
              const cardBlock = this.baseFieldService.find(field => field.field === 'card');
              const uploadPromises = cardBlock.cards.map(async (card, idx) => {
                const formDataCardImage = new FormData();
                formDataCardImage.set('file', card.image);
                const data = {
                  id: initialState.featuresModule.images[idx].id,
                  formData: formDataCardImage,
                };
                try {
                  const uploadImage = await this.UPLOAD_IMAGES_IN_MODULE(data);
                  initialState.featuresModule.images[idx] = uploadImage;
                  return { success: true, data: initialState };
                } catch (error) {
                  console.error('загрузка с ошибкой', error);
                  return { success: false, error, card };
                }
              });
              const results = await Promise.all(uploadPromises);
              results.forEach(result => {
                if (result.success) {
                  console.log('Успешно загружено:', result.data);
                } else {
                  console.error('Ошибка загрузки:', result.error);
                }
              });
            }
          } catch (error) {
            console.log('Ошибка загрузки изображения', error);
            return error;
          }
        }

        // Обновление изображений карточек услуг

        // Загружаем в модуль изображение
        try {
          const cardBlock = this.baseFieldService.find(field => field.field === 'card');
          const uploadPromises = cardBlock.cards.map(async (card, idx) => {
            const formDataCardImage = new FormData();
            formDataCardImage.set('file', card.image);
            const data = {
              id: this.serviceDetails.modules[cardModule].images[idx].id,
              formData: formDataCardImage,
            };
            try {
              const uploadImage = await this.UPLOAD_IMAGES_IN_MODULE(data);
              return { success: true, data: uploadImage };
            } catch (error) {
              console.error('загрузка с ошибкой', error);
              return { success: false, error, card };
            }
          });
          const results = await Promise.all(uploadPromises);
          results.forEach(result => {
            if (result.success) {
              console.log('Успешно загружено:', result.data);
            } else {
              console.error('Ошибка загрузки:', result.error);
            }
          });
        } catch (error) {
          return error;
        }
        /* -------------------END FEATURES-------------------------- */

        /* -------------------CONTACT BUTTON-------------------------- */
        try {
          const cardTitleBlock = this.baseFieldService.find(field => field.field === 'callBack');
          const data = {
            card: {
              id: this.serviceDetails.id,
            },
            module: {
              id: this.serviceDetails.modules[callBackModule].id,
              module_type: 'contact_button',
              text: cardTitleBlock.inputValue,
            }
          };
          await this.UPDATE_MODULE(data);
        } catch (error) {
          console.error('Ошибка обнволения модуля (contact_button)', error);
          return error;
        }

        /* -------------------END CONTACT BUTTON-------------------------- */

        /* -------------------START PREVIEW MODULE-------------------------- */
        try {
          const previewField = this.getFieldValue('report_preview', 'reportPreview');
          const typePreview = previewField.type;
          const shouldCreateModule = (typePreview) => {
            if (typePreview === 'image') {
              return !!this.serviceDetails.modules[previewModule].images.length;
            }
            if (typePreview === 'file') {
              return !!this.serviceDetails.modules[previewModule].files.length;
            }
          };
          if (typePreview === 'image') {
            const createModule = shouldCreateModule('image');
            if (!createModule) {
              await this.createReportPreviewModule(true);
            } else {
              try {
                const reportPreview = this.baseFieldService.find(field => field.field === 'report_preview');
                if (reportPreview) {
                  const formReportPreview = new FormData();
                  formReportPreview.set('file', reportPreview.preview);
                  const data = {
                    formData: formReportPreview,
                    id: this.serviceDetails.modules[previewModule].images[0].id,
                  };
                 await this.UPLOAD_IMAGES_IN_MODULE(data);
                }
              } catch (error) {
                return error;
              }
            }
            if (this.serviceDetails.modules[previewModule].files.length >= 1) {
              await this.deleteModuleImage('file', this.serviceDetails.modules[previewModule].files[0].id);
            }
          }
          if (typePreview === 'file') {
            const createModule = shouldCreateModule('file');
            if (!createModule) {
              await this.createReportPreviewModule(true);
            } else {
              try {
                const reportPreview = this.baseFieldService.find(field => field.field === 'report_preview');
                if (reportPreview) {
                  const formReportPreview = new FormData();
                  formReportPreview.set('file', reportPreview.previewFile);
                  const data = {
                    formData: formReportPreview,
                    id: this.serviceDetails.modules[previewModule].files[0].id,
                  };
                  await this.UPLOAD_FILES_IN_MODULE(data);
                }
              } catch (error) {
                return error;
              }
            }
            if (this.serviceDetails.modules[previewModule].images.length >= 1) {
              await this.deleteModuleImage('image', this.serviceDetails.modules[previewModule].images[0].id);
            }
          }
          shouldCreateModule();
          if (previewField) {
            const formDataPreview = new FormData();
            formDataPreview.set('file', previewField.preview);
            const data = {
              formData: formDataPreview,
              id: this.serviceDetails.modules[previewModule].images[0].id,
            };
            await this.UPLOAD_IMAGES_IN_MODULE(data);
          }
        } catch (error) {
          return error;
        }
        /* -------------------END PREVIEW MODULE-------------------------- */
         this.SET_SUCCESS_MODAL_UPDATE(true);
      } catch (error) {
        console.error('Ошибка обновления карточки услуги', error);
      }
    },
    initializeFormValues() {
      this.baseFieldService.forEach(field => {
        if (field.validation) {
          const fieldName = `field_${field.field}`;
          this.$set(this.formValues, fieldName, field.inputValue || '');
        }
      });
    },
    updateField(index, value, type = 'input') {
      const field = this.baseFieldService[index];
      if (type === 'input') {
        this.$set(field, 'inputValue', value);
      }

      if (field.validation) {
        const fieldName = `field_${field.field}`;
        this.$set(this.formValues, fieldName, value);
      }
    },
    touchField(index) {
      const field = this.baseFieldService[index];
      if (!field.validation) return;

      this.$set(this.touchedFields, index, true);

      const fieldName = `field_${field.field}`;
      if (this.$v.formValues[fieldName]) {
        this.$v.formValues[fieldName].$touch();
      }
    },
    showError(index) {
      const field = this.baseFieldService[index];
      if (!field.validation) return false;

      return this.touchedFields[index] && this.getFieldError(index);
    },
    getFieldError(index) {
      const field = this.baseFieldService[index];
      if (!field.validation) return '';

      const fieldName = `field_${field.field}`;
      const validator = this.$v.formValues[fieldName];

      if (!validator || !validator.$error) return '';

      if (validator.required === false) {
        return 'Это поле обязательно';
      }

      if (validator.minLength === false) {
        return `Минимум ${field.validation.minLength} символов`;
      }

      if (validator.maxLength === false) {
        return `Максимум ${field.validation.maxLength} символов`;
      }

      if (validator.numeric === false) {
        return 'Только числа';
      }

      if (validator.between === false) {
        return `Должно быть между ${field.validation.between[0]} и ${field.validation.between[1]}`;
      }

      if (validator.countImage === false) {
        return 'Минимальное количетсво заполненых карточек - 3';
      }

      if (validator.format === false) {
        return 'Допустимые форматы .jpg, .png, .webp';
      }

      if (validator.requiredDescription === false) {
        return 'Описание карточек обяательно к заполенению мин 10 символов, макс - 2000';
      }
      return 'Ошибка валидации';
    },
    // <----------- EDIT ----------->
    async fillRequiredFields() {
      let canRestart = false;
      this.nomenclatureKnown = 'nomenclature' in this.serviceDetails;
      this.nomenclatureId = this.nomenclatureIdOf(this.serviceDetails.nomenclature) || null;
      this.keepSelectedNomenclature();
      // initial data
      const mainTitleField = this.baseFieldService.findIndex(field => field.field === 'mainTitle');
      const shortDescriptionField = this.baseFieldService.findIndex(field => field.field === 'shortDescription');
      const mainImageField = this.baseFieldService.findIndex(field => field.field === 'mainImage');
      const fullDescriptionField = this.baseFieldService.findIndex(field => field.field === 'fullDescription');
      const cardTitleField = this.baseFieldService.findIndex(field => field.field === 'cardTitle');
      const cardField = this.baseFieldService.findIndex(field => field.field === 'card');
      const callBackField = this.baseFieldService.findIndex(field => field.field === 'callBack');
      const priceField = this.baseFieldService.findIndex(field => field.field === 'price');
      const saleField = this.baseFieldService.findIndex(field => field.field === 'sale');
      const previewField = this.baseFieldService.findIndex(field => field.field === 'report_preview');

      // Modules Required
      const mainImageModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'main_image');
      const cardModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'features');
      const callBackModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'contact_button');
      const previewModule = this.serviceDetails.modules.findIndex(module => module.module_type === 'report_preview');

      // mainTitleField fill
      this.baseFieldService[mainTitleField].inputValue = this.serviceDetails.name;
      this.updateField(mainTitleField, this.serviceDetails.name);

      // shortDescriptionField fill
      this.baseFieldService[shortDescriptionField].inputValue = this.serviceDetails.short_description;
      this.updateField(shortDescriptionField, this.serviceDetails.short_description);

      // mainImageField fill
      try {
        const mainImageUrl = this.serviceDetails.modules[mainImageModule].images[this.serviceDetails.modules[mainImageModule].images.length - 1].image_url;
        const imageBlob = await this.urlToFile(mainImageUrl);
        this.baseFieldService[mainImageField].mainImageBase64 = mainImageUrl;
        this.baseFieldService[mainImageField].mainImage = imageBlob;
        this.updateField(mainImageField, imageBlob, 'file');
      } catch (error) {
        console.log(error);
      }

      // fullDescriptionField fill
      this.baseFieldService[fullDescriptionField].inputValue = this.serviceDetails.full_description;
      this.updateField(fullDescriptionField, this.serviceDetails.full_description);

      // cardTitleField fill
      this.baseFieldService[cardTitleField].inputValue = this.serviceDetails.modules[cardModule].text;
      this.updateField(cardTitleField, this.serviceDetails.modules[cardModule].text);

      // cardField fill
      try {
        if (this.serviceDetails.modules[cardModule].images.length) {
          const cardPromises = this.serviceDetails.modules[cardModule].images.map(async (card) => {
            let imageFile = null;

            try {
              if (card.image_url) {
                imageFile = await this.urlToFile(card.image_url);
              }
            } catch (error) {
              console.warn(`Не удалось загрузить изображение для ${card.name}:`, error);
            }

            return {
              id: card.id,
              image: imageFile,
              imageBase64: card.image_url,
              description: card.caption,
            };
          });
          this.baseFieldService[cardField].cards = await Promise.all(cardPromises);
          // Если не создались 3 карточки
          if (this.serviceDetails.modules[cardModule].images.length < 3) {
            canRestart = true;
            const countEmptyCards = 3 - this.serviceDetails.modules[cardModule].images.length;
            const promises = [];

            for (let i = 1; i <= countEmptyCards; i += 1) {
              const promise = (async (cardNumber) => {
                try {
                  const initialState = {
                    featuresModule: this.serviceDetails.modules[cardModule],
                  };
                  if (!initialState.featuresModule) {
                    return { success: false, card: cardNumber, error: 'Модуль не найден' };
                  }

                  initialState.featuresModule.images = [];

                  const data = {
                    id: initialState.featuresModule.id,
                    caption: '',
                  };

                  const createImagesBlockInModule = await this.CREATE_IMAGES_BLOCK_FOR_MODULE(data);
                  initialState.featuresModule.images.push(createImagesBlockInModule);

                  return {
                    success: true,
                    card: cardNumber,
                    data: createImagesBlockInModule
                  };
                } catch (error) {
                  return {
                    success: false,
                    card: cardNumber,
                    error: error.message
                  };
                }
              })(i);

              promises.push(promise);
            }
            await Promise.allSettled(promises);
          }
          this.updateField(cardField, this.baseFieldService[cardField]?.cards, 'card');
        }
      } catch (error) {
        console.error('Ошибка при загрузке карточек:', error);
      }

      // callBackField fill
      this.baseFieldService[callBackField].inputValue = this.serviceDetails.modules[callBackModule].text;
      this.updateField(callBackField, this.serviceDetails.modules[callBackModule].text);

      // priceField fill
      this.baseFieldService[priceField].inputValue = this.serviceDetails.price;
      this.updateField(priceField, this.serviceDetails.price);

      // saleField fill
      this.baseFieldService[saleField].inputValue = this.serviceDetails.discount_price;
      this.updateField(saleField, this.serviceDetails.discount_price);

      // previewField fill
      try {
        if (this.serviceDetails.modules[previewModule]?.images?.length) {
          const previewUrl = this.serviceDetails.modules[previewModule].images[this.serviceDetails.modules[previewModule].images.length - 1].image_url;
          if (previewUrl) {
            const imageBlob = await this.urlToFile(previewUrl);
            this.baseFieldService[previewField].previewBase64 = previewUrl;
            this.baseFieldService[previewField].preview = imageBlob;
            this.updateField(previewField, imageBlob, 'file');
          }
        }
        if (this.serviceDetails.modules[previewModule]?.files?.length) {
          const previewUrl = this.serviceDetails.modules[previewModule].files[this.serviceDetails.modules[previewModule].files.length - 1].file_url;
          if (previewUrl) {
            const imageBlob = await this.urlToFile(previewUrl);
            this.baseFieldService[previewField].previewFileBase64 = previewUrl;
            this.baseFieldService[previewField].previewFile = imageBlob;
            this.updateField(previewField, imageBlob, 'file');
          }
        }
      } catch (error) {
        throw new Error(error);
      }
      if (canRestart) {
        await this.GET_DETAIL_SERVICE_CARD(this.editPageId);
        await this.fillRequiredFields();
      }
    },
    async urlToFile(imageUrl, fileName = null) {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error(`Ошибка загрузки: ${response.status}`);
        }
        const blob = await response.blob();
        let finalFileName = fileName;
        if (!finalFileName) {
          const urlObj = new URL(imageUrl);
          const pathParts = urlObj.pathname.split('/');
          finalFileName = pathParts[pathParts.length - 1] || 'image';
        }

        let mimeType = blob.type;

        if (mimeType === 'binary/octet-stream'
          || mimeType === 'application/octet-stream'
          || !mimeType
          || mimeType === '') {
          let extension = '';

          if (finalFileName.includes('.')) {
            extension = finalFileName.split('.').pop().toLowerCase();
          } else {
            const urlExtension = imageUrl.split('.').pop().split('?')[0].toLowerCase();
            extension = urlExtension;
            finalFileName = `image.${extension}`;
          }
          const mimeMap = {
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
            webp: 'image/webp',
            svg: 'image/svg+xml',
            bmp: 'image/bmp',
            ico: 'image/x-icon',
            tiff: 'image/tiff',
            tif: 'image/tiff',
            pdf: 'application/pdf',
            doc: 'application/msword',
            docx: 'application/msword',
          };

          mimeType = mimeMap[extension] || 'image/jpeg';
        }

        const file = new File([blob], finalFileName, {
          type: mimeType,
          lastModified: Date.now()
        });
        return file;
      } catch (error) {
        throw new Error(error);
      }
    },
    closeSuccesModal() {
        this.$router.push('/admin-panel/services');
        this.SET_SUCCESS_MODAL_UPDATE(false);
        this.SET_SUCCESS_MODAL_CREATE(false);
    }
  },
};
</script>

<style scoped lang="scss">
.nomenclatureBlock {
  max-width: 560px;
  margin-bottom: 24px;
}
.CreateService {
  & .fieldWrapper{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
  & .btnDownBlocks{
    display: flex;
    flex-wrap: nowrap;
    padding-top: 16px;
    gap: 16px;
    & .v-btn{
      background: var(--color-blue-500);
      border-radius: 6px;
      height: 100%;
      font-size: 16px;
      padding: 10px 16px;
      ::v-deep span{
        line-height: 24px;
      }
      &.background_transparent{
        background: transparent;
        color: var(--color-blue-500)!important;
      }
    }
  }
  /* Стили компонента */
}
</style>
